// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".3d04969d459521ff7081b548458073791a4dcbb2.chunk.js";
};